<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3 text-uppercase">{{ $t('Physical_Branches') }}</h3>
        </div>
      </div>
    </div>

    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-12 mx-auto" v-if="isLoadData">
            <div class="row my-3 d-flex align-items-center">
              <div class="col-lg-6 col-md-6 col-12">
                <input
                  class="nosubmit w-100"
                  type="search"
                  v-model="searchKeyword"
                  :placeholder="$t('Search_Name_Address')"
                  @input="onChangeSearchKeyword"
                />
              </div>
            </div>
            <p class="text-xs text-muted mb-0">{{ $t('Testing_Account_Hint') }}</p>

            <div class="row mt-3">
              <div class="col-12">
                <div class="card-custom">
                  <!-- Desktop table -->
                  <div class="table-responsive p-0 custom-table d-none d-md-block">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bolder">{{ $t('Physical_Branch_Name') }}</th>
                          <th class="text-center font-weight-bolder">{{ $t('Code') }}</th>
                          <th class="text-center font-weight-bolder">{{ $t('Address') }}</th>
                          <th class="text-center font-weight-bolder">{{ $t('status') }}</th>
                          <th class="text-center font-weight-bolder">{{ $t('Testing_Account') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!physicalBranches.length">
                          <td colspan="5" class="text-center text-xss">No data</td>
                        </tr>
                        <tr v-for="branch in physicalBranches" :key="branch.id">
                          <td class="text-center text-xss w-25">{{ branch.name }}</td>
                          <td class="text-center text-xss w-10">{{ branch.code }}</td>
                          <td class="text-center text-xss">{{ branch.address }}</td>
                          <td class="align-middle text-center w-10">
                            <span
                              class="badge badge-sm"
                              :class="branch.status == 1 ? 'bg-gradient-success' : 'bg-danger'"
                            >
                              {{ branch.status == 1 ? 'Active' : 'Deactive' }}
                            </span>
                          </td>
                          <td class="align-middle text-center w-15">
                            <div class="form-check form-switch d-inline-flex align-items-center ps-0 mb-0">
                              <input
                                :id="'testing_' + branch.id"
                                class="form-check-input ms-0"
                                type="checkbox"
                                :checked="branch.is_testing == 1"
                                :disabled="togglingId === branch.id"
                                @change="setTesting(branch, $event)"
                              />
                              <label
                                :for="'testing_' + branch.id"
                                class="form-check-label ms-2 mb-0 fw-bold toggle-label"
                                :class="branch.is_testing == 1 ? 'text-warning' : 'text-secondary'"
                              >
                                {{ branch.is_testing == 1 ? 'ON' : 'OFF' }}
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Mobile cards -->
                  <div class="d-block d-md-none pt-2 pb-3">
                    <div v-if="!physicalBranches.length" class="text-center text-xss">No data</div>
                    <div
                      v-for="branch in physicalBranches"
                      :key="'card-' + branch.id"
                      class="mobile-card mb-3 p-3"
                    >
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <span class="text-sm fw-bold">{{ branch.name }}</span>
                        <span
                          class="badge badge-sm"
                          :class="branch.status == 1 ? 'bg-gradient-success' : 'bg-danger'"
                        >
                          {{ branch.status == 1 ? 'Active' : 'Deactive' }}
                        </span>
                      </div>
                      <div class="mb-1">
                        <span class="mobile-label">{{ $t('Code') }}:</span>
                        <span class="text-xss ms-1">{{ branch.code }}</span>
                      </div>
                      <div class="mb-2">
                        <span class="mobile-label">{{ $t('Address') }}:</span>
                        <span class="text-xss ms-1">{{ branch.address }}</span>
                      </div>
                      <div class="form-check form-switch d-flex align-items-center ps-0 mb-0">
                        <span class="mobile-label me-2">{{ $t('Testing_Account') }}:</span>
                        <input
                          :id="'testing_m_' + branch.id"
                          class="form-check-input ms-0"
                          type="checkbox"
                          :checked="branch.is_testing == 1"
                          :disabled="togglingId === branch.id"
                          @change="setTesting(branch, $event)"
                        />
                        <label
                          :for="'testing_m_' + branch.id"
                          class="form-check-label ms-2 mb-0 fw-bold toggle-label"
                          :class="branch.is_testing == 1 ? 'text-warning' : 'text-secondary'"
                        >
                          {{ branch.is_testing == 1 ? 'ON' : 'OFF' }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import PhysicalBranchService from "../../../services/physicalBranch.service";

// M1084: every outlet of the merchant with its "Testing Account" switch. A testing
// outlet still sells; the dashboard and reports just leave it out.
export default {
  name: "physical-branch-list",
  components: {
    MaterialSnackbar,
    MaterialLoading,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      isLoadData: false,
      physicalBranches: [],
      searchKeyword: "",
      searchTimerId: null,
      togglingId: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    closeSnackbar() {
      this.snackbar = null;
    },
    notify(type, message) {
      this.snackbar = type;
      this.message = message;
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    onChangeSearchKeyword() {
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList();
      }, 1000);
    },
    getList() {
      this.loaderActive = true;
      PhysicalBranchService.getList({ search_keyword: this.searchKeyword }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.physicalBranches = response.data.data.physical_branches;
            this.isLoadData = true;
          } else {
            this.notify("danger", response.data.result.message);
          }
          this.loaderActive = false;
        },
        (error) => {
          this.notify("danger", error?.response?.data?.result?.message || error.message);
          this.loaderActive = false;
        }
      );
    },
    setTesting(branch, event) {
      const isTesting = event.target.checked;
      this.togglingId = branch.id;
      PhysicalBranchService.updateTesting(branch.id, isTesting).then(
        (response) => {
          this.togglingId = null;
          if (response.data.result.isSuccess) {
            branch.is_testing = response.data.data.is_testing;
            this.notify("success", `${branch.name}: ${this.$t('Testing_Account')} ${isTesting ? 'ON' : 'OFF'}`);
          } else {
            event.target.checked = !isTesting;
            this.notify("danger", response.data.result.message);
          }
        },
        (error) => {
          this.togglingId = null;
          event.target.checked = !isTesting;
          this.notify("danger", error?.response?.data?.result?.message || error.message);
        }
      );
    },
  },
};
</script>

<style scoped>
input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  font-size: 14px;
  color: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
}

input[type="search"]:focus {
  outline: none;
  border-bottom: 1px solid #ffbe30;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.toggle-label {
  min-width: 28px;
  text-align: left;
}

.mobile-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.mobile-label {
  font-weight: bold;
  color: #000;
}
</style>
